import IconTearDropButton from "../CommonButtons/IconTearDropButton";

/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @param {Object} props
 * @param {string} props.header - container card header
 * @param {string} [props.subheader] - container card description
 * @param {string} [props.icon] - action icon of the container card
 * @param {boolean} [props.iconIsDisabled] - whether the action on the card needs to be disabled or not
 * @param {OnClickEventHandler} props.handleFunction - what to do when click on button
 * @param {JSX.ELement} props.children - the code comprising of the cards or chips to be rendered
 * @returns {JSX.Element}
 **/

const CommonContainerCard = ({
  header,
  subheader,
  icon,
  iconIsDisabled,
  handleFunction,
  children,
}) => {
  return (
    <>
      <div className="bg-primary-card py-padding-md mx-mobile-margin-l Qmd:mx-margin-md Qlg:mx-margin-base rounded-border-radius-md relative max-h-common-container-card-max-height flex flex-col">
        <div className="flex flex-col gap-y-gap-xs mb-margin-md">
          <p className="text-font-sm text-text-primary font-semibold px-padding-md">
            {header}
          </p>
          {subheader && (
            <p className="text-font-xs text-text-secondary font-normal px-padding-md">
              {subheader}
            </p>
          )}
        </div>

        <div className="relative overflow-y-auto px-padding-md">{children}</div>

        {icon && (
          <div className="absolute bg-primary-act top-top-base right-right-base rounded-tr-border-radius-md rounded-bl-border-radius-md">
            <IconTearDropButton
              btnType="button"
              handleFunction={handleFunction}
              isDisabled={iconIsDisabled}
              enabledBgColor={"var(--(primary-act)"}
              disabledBgColor={"var(--(text-secondary)"}
              isLoading={false}
              icon={icon}
              hoverOption="white"
              title={"Edit"}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CommonContainerCard;
